import * as React from "react";
// Utilities
import { Switch } from "react-router";
//Shared components
import PrivateRoute from "components/PrivateRoute";
// Local components
import Request from "./screens/Request";
import { SettlementType } from "services/http/endpoints/settlement";

interface IState {
	settlements: Array<SettlementType>;
	settlement?: SettlementType | any;
	current: number;
}

type IAction = Partial<IState>;

const initialState = () => ({ settlements: [], current: 0, settlement: {} } as IState);

function reducer(state: IState, action: IAction): IState {
	return { ...state, ...action };
}

interface IContextProps {
	state: IState;
	dispatch: any;
}

const SettlementContext = React.createContext({
	state: initialState(),
	dispatch: () => {},
} as IContextProps);

const Settlements: React.FC = () => {
	const [store, dispatch] = React.useReducer(reducer, initialState());
	return (
		<Switch>
			<SettlementContext.Provider value={{ state: store, dispatch }}>
				<PrivateRoute path="/dashboard/settlements/request" component={Request} />
			</SettlementContext.Provider>
		</Switch>
	);
};

export const useFacilities = () => React.useContext(SettlementContext);

export default Settlements;
